module.exports = __webpack_public_path__ + "img/button_diameter.8601bce4.png";